type ImageSource = {
  type: string;
  srcSet: string;
};

type Props = {
  alt: string;
  src: string;
  width: number;
  height: number;
  sources: ImageSource[];
  sizes: string;
  className?: string;
  pictureClassName?: string;
  loading?: "eager" | "lazy";
  fetchPriority?: "high" | "low" | "auto";
  decoding?: "async" | "auto" | "sync";
};

export function ResponsiveImage({
  alt,
  src,
  width,
  height,
  sources,
  sizes,
  className,
  pictureClassName,
  loading = "lazy",
  fetchPriority,
  decoding = "async",
}: Props) {
  const isLcp = fetchPriority === "high";
  const resolvedLoading = isLcp ? "eager" : loading;
  // Put srcset on the <img> so the preload scanner can start LCP without
  // waiting to evaluate <picture><source type>.
  const lcpSrcSet = isLcp ? sources[0]?.srcSet : undefined;

  return (
    <picture className={pictureClassName}>
      {sources.map((source) => (
        <source key={source.type} type={source.type} srcSet={source.srcSet} sizes={sizes} />
      ))}
      <img
        src={src}
        srcSet={lcpSrcSet}
        sizes={lcpSrcSet ? sizes : undefined}
        alt={alt}
        width={width}
        height={height}
        style={{ aspectRatio: `${width} / ${height}` }}
        className={className}
        loading={resolvedLoading}
        fetchPriority={fetchPriority}
        decoding={isLcp ? "auto" : decoding}
      />
    </picture>
  );
}
